export const lang = [{id: "es", name: "ES"}, {id: "ca", name: "CA"}, {id: "en", name: "EN"}, {id: "fr", name: "FR"}]
